import React from 'react';
import { BAG_FIRST } from '../bagFirst';

export const OrderStatus = ({ order }) => {
  // bag-first（2026-09-01の初回登録フロー刷新）:
  // 初回コースは注文後まず専用バッグだけをお届けし、到着後にお客様が改めて集荷を依頼する。
  // この間 otype は 1 のままなので、otype だけでは「集荷待ち」としか出せず、
  // お客様が今どこにいるのか（待つのか／動くのか）が分からない。bag_status を優先して見る。
  const bagStatus = BAG_FIRST ? String(order.bag_status || '') : '';

  // otypeに基づいてステータス名を決定
  const getStatusName = () => {
    if (order.status_name) return order.status_name; // status_nameが提供されている場合はそれを使用

    if (Number(order.otype) === 1) {
      if (bagStatus === 'delivering') return '専用バッグをお届け中';
      if (bagStatus === 'arrived') return '専用バッグが届きました';
    }

    switch (Number(order.otype)) {
      case 1:
        // item_typeがbagやfuton_bagの場合は"配送中"
        if (order.item_type === 'bag' || order.item_type === 'futon_bag') {
          return 'バッグ配送中';
        }
        if (Number(order.is_dropoff_box) === 0 && order.uber_dropoff_type === 'own'){
          return '店舗にお持ちください';
        }
        return '集荷待ち';
      case 2: return 'お預り品配送中';
      case 3: return 'クリーニング中';
      case 4: return 'クリーニング中';
      case 5: return 'クリーニング中';
      case 6: return '仕上り済・お受け取りください';
      case 7: return '仕上り品お届け中';
      case 8: return 'お受け取り済み';
      case 11: return 'キャンセル';
      case 13: return order.visit_confirmed ? 'スタッフ訪問・日程確定' : 'スタッフ訪問・日程調整中';
      default: return '';
    }
  };

  // otype を色分け用の種別へ。集荷/配送=青, クリーニング=黄, 仕上り受取=緑(要対応),
  // 完了=灰, キャンセル=赤。これで一覧でも状態が一目で分かる。
  const getKind = () => {
    const n = Number(order.otype);
    if (n === 11) return 'cancel';
    // バッグ到着＝お客様に動いてもらう番なので、仕上り受取と同じ「要対応」の緑にする
    if (n === 1 && bagStatus === 'arrived') return 'ready';
    if (n === 8) return 'done';
    if (n === 6) return 'ready'; // 仕上り済・お受け取りください（お客様の対応が必要）
    if (n >= 3 && n <= 5) return 'cleaning';
    return 'pickup'; // 1,2,7 集荷・配送
  };

  return (
    <div className={`order_status os-${getKind()}`}>
      {getStatusName()}
    </div>
  );
};

export default OrderStatus;
